import React, { useRef, useEffect, useState } from "react";
import "./CollapsibleSection.css";

const CollapsibleSection = ({ title, children, isOpen, onToggle, afterExpand }) => {
    const contentRef = useRef(null);
    const [maxHeight, setMaxHeight] = useState("0px");

    useEffect(() => {
        const el = contentRef.current;
        if (!el) return;

        if (isOpen) {
            setTimeout(() => {
                setMaxHeight(`${el.scrollHeight}px`);

                // ⏳ Fire callback AFTER expansion completes
                setTimeout(() => {
                    if (typeof afterExpand === "function") {
                        afterExpand();
                    }
                }, 300); // Match transition time
            }, 10);
        } else {
            setMaxHeight("0px");
        }
    }, [isOpen, children]);

    return (
        <div className="collapsible-section">
            <div className="collapsible-header" onClick={onToggle}>
                <h3>{isOpen ? "▼" : "▶"} {title}</h3>
                <span className="toggle-icon">{isOpen ? "−" : "+"}</span>
            </div>
            <div
                className="collapsible-body"
                ref={contentRef}
                style={{
                    maxHeight,
                    overflow: "hidden",
                    transition: "max-height 0.3s ease",
                }}
            >
                <div className="collapsible-inner">{children}</div>
            </div>
        </div>
    );
};

export default CollapsibleSection;